import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import './index.less';

const PANE_RISK = 'pane1';
const PANE_CASE = 'pane2';

const cases = [
  {
    title: '虚假信息案例一',
    data: [
      {
        text: '虚假信息案例一',
        center: true,
        bold: true,
        big: true,
      },
      {
        text: '国家农业再投入专项扶持贷款项目介绍',
        center: true,
        bold: true,
        medium: true,
      },
      { text: '一、项目性质', bold: true },
      { text: '本项目是由国家农业农村部发起的专项扶持贷款，旨在应对疫情及近期农业发展中的突出问题，支持符合条件的农业企业，促进就业与农业可持续发展。' },
      { text: '二、资金特点', bold: true },
      { text: '·贷款额度大:首期可达4-12亿元' },
      { text: '·利率极低:年化利率仅为0.8%' },
      { text: '·不占用企业现有银行授信额度' },
      { text: '·资金直接划入企业账户' },
      { text: '三、项目周期', bold: true },
      { text: '初期贷款期限为15年。若企业持续运营良好，可申请续期。项目申报预计于6月底截止，需抓紧时间推进。' },
      { text: '四、核心条件', bold: true },
      { text: '企业需具备一定的经营规模与信用资质，符合农业农村部相关扶持政策要求。' },
      { text: '五、申报流程', bold: true },
      { text: '1.企业将申报材料提交至农业农村部进行初步审核;' },
      { text: '2.审核通过后，企业纳入“农业农村部融资项目库”;' },
      { text: '3.项目入库后，农业农村部将派2人赴企业现场考察，差旅费用由项目方承担，并当面洽谈合作细节;' },
      { text: '4.企业按“县一市一省一部”的层级顺序，逐级上报并加盖公章;' },
      { text: '5.最终由农业农村部审批并发放贷款。' },
      { text: '六、所需材料(共5项)', bold: true },
      { text: '·可行性研究报告' },
      { text: '·营业执照' },
      { text: '·项目备案证' },
      { text: '·近三年财务报告(含负债情况)' },
      { text: '·土地证(包括流转土地与农民签订的合作合同)' },
    ],
  },
  {
    title: '虚假信息案例二',
    data: [
      {
        text: '虚假信息案例二',
        center: true,
        bold: true,
        big: true,
      },
      {
        text: '农业农村部专项资金《立体 AI 养虾项目》简介',
        center: true,
        bold: true,
        medium: true,
      },
      { text: '一、项目背景', bold: true },
      { text: '农业农村部、国家发改委、财政部、自然资源部文件【2023】6 号文件名为：农业农村部 国家发展改革委 财政部 自然资源部 关于印发《全国现代设施农业建设规划 (2023—2030 年) 》的通知，具体内容详见红头文件' },
      { text: '二、项目特点', bold: true },
      { text: '1、农业部承担国家重点民生项目' },
      { text: '2、投资全由国家承担' },
      { text: '3、产品全国家全款统购，收购期20年' },
      { text: '4、为当地创造 GDP 及税收' },
      { text: '三、汇报要点', bold: true },
      { text: '1、项目落地:区县，每个地级市落1个，10月份截止。' },
      { text: '2、国家重点项目，专属资金（不走地方财政）' },
      { text: '3、地方政府需要准备至少 300 亩设施农业用地' },
      { text: '4、申报流程:我方在当地先成立公司，办理项目备案证，然后项目申报资料审核通过后先录入农业农村部项目平台，届时该项目会有专属用户名和密码，然后回到县农业农村局-市农业农村局-省农业厅-农业农村部计财司，然后央企混改，招标，开工，运维。' },
      { text: '5、条件成熟后，我方(作为牵头人)在当地以自己的私人身份成立一间智慧养殖科技公司，农业部委托国开行通过专项资金全资注入这间新公司(款项是专项款，必须专款专用，不能挪用)，专项款到位后，农业部将委托某央国企来接管这间公司，经营公司在当地有可以创造GDP至少每年3至5亿，创造税收至少3千万以上，所有产出的瞎是国家全资收购！' },
      { text: '四、该项目特点', bold: true },
      { text: '1、农业部承担国家重点民生项目' },
      { text: '2、投资全由国家承担' },
      { text: '3、产品全国家全款统购' },
      { text: '4、为当地创造 GDP 及税收和就业' },
      { text: '备注:以上申报由我们团队全权负责，当地政府准备好符合要求的土地，然后全力配合即可！' },
      { text: '五、项目条件', bold: true },
      { text: '1、由区县农业农村局的负责找好300亩以上，20年租期的土地(可是 600，900，甚至1000以上，增加观光文旅项目)。300亩及以上连片的农业设施用地，需要县农业局同意备案和配合申报。' },
      { text: '2、发地理位置座标及卫星地形图。' },
      { text: '3、并报区县级地方相关单位将参加电话会人员名单上报我方。' },
      { text: '4、以上三步准备好，我方负责约部里相关负责人跟县里相关负责人开电话会议！' },
      { text: '六、项目主体', bold: true },
      { text: '农业农村部计划财务司专项资金，由部委根据所在地方，匹配央国企，由央国企出资 30%，剩余资金部里匹配。' },
      { text: '七、需要落实', bold: true },
      { text: '1、县及农村农业局领导是否配合' },
      { text: '2、土地面积(300亩以上)' },
      { text: '3、租金多少一亩，20年以上' },
      { text: '4、座标，卫星图' },
      { text: '5、我方负责报件，由部委相关领导和县里相关负责人线上会议或者组织线下。' },
      { text: '八、其他补充', bold: true },
      { text: '（一）、用地定性（关键）' },
      { text: '1. 设施农用地：' },
      { text: '- AI 立体养虾、室内多层养殖桶/养殖槽、循环水车间统一归类：水产养殖生产设施用地，属于设施农用地（农用地管理）' },
      { text: '2. 核心权益：' },
      { text: '- 无需办理建设用地转用、征地、建设用地审批' },
      { text: '- 执行乡镇备案制，手续简单' },
      { text: '- 不占用建设用地指标、无需增减挂钩' },
      { text: '（二）、土地准入红线（必看，避免违建）' },
      { text: '1. 允许使用' },
      { text: '- 一般耕地、园地、空闲农用地、坑塘水面、废弃养殖用地' },
      { text: '2. 严格禁止' },
      { text: '- 永久基本农田（工厂化硬化、破坏耕作层，一律不准）- 生态保护红线、饮用水源保护区、河道蓝线、行洪区' },
      { text: '- 城镇开发边界核心建成区' },
      { text: '3. 硬化&建设要求' },
      { text: '- 养殖车间、养殖池、立体养殖钢架设备：允许合理硬化（水产养殖刚需）' },
      { text: '- 严禁：建设住宅、办公楼、商铺、民宿、永久性非农大楼' },
      { text: '- 必须签订土地复垦协议，养殖到期后恢复农业用途' },
      { text: '（三）、辅助设施用地比例管控（全国通用标准）' },
      { text: '1. 水产养殖类设施农用地' },
      { text: '- 生产设施（养殖车间、立体养殖区、RAS 循环水处理区、尾水处理）： 不限比例，按需合理建设' },
      { text: '- 配套辅助设施（仓库、农资间、工具房、简易看护房、消毒用房）： 占地面积≤养殖总用地面积的 1.5%' },
    ],
  },
];

export default function RiskModal({ open, onClose }) {
  const [activePane, setActivePane] = useState(PANE_RISK);

  // 每次打开时重置到“风险提示”正文
  useEffect(() => {
    if (open) {
      setActivePane(PANE_RISK);
    }
  }, [open]);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={900}
      className="risk-modal"
      destroyOnClose
    >
      <div className="risk-modal__head">
        <div className="risk-modal__head-badge">
          <svg viewBox="0 0 24 24" fill="none">
            <path d="M12 2.6 4.8 5.4v6.1c0 4.6 3 8.7 7.2 9.9 4.2-1.2 7.2-5.3 7.2-9.9V5.4L12 2.6Z" fill="#fff" />
            <path d="M12 7.3v4.4" stroke="#FA8C16" strokeWidth="2" strokeLinecap="round" />
            <circle cx="12" cy="14.7" r="1.25" fill="#FA8C16" />
          </svg>
        </div>
        <div className="risk-modal__head-text">
          <div className="risk-modal__head-title">风险提示</div>
          <div className="risk-modal__head-sub">防范金融诈骗 · 远离非法集资 · 保护您的合法权益</div>
        </div>
      </div>

      <div className="risk-modal__tabs">
        <button
          type="button"
          className={activePane === PANE_RISK ? 'on' : ''}
          onClick={() => setActivePane(PANE_RISK)}
        >
          风险提示
        </button>
        <button
          type="button"
          className={activePane === PANE_CASE ? 'on' : ''}
          onClick={() => setActivePane(PANE_CASE)}
        >
          典型案例
          <span className="risk-modal__pill">2 例</span>
        </button>
      </div>

      <div className="risk-modal__body">
        {activePane === PANE_RISK ? (
          <div className="risk-modal__pane">
            <p>
              近期，社会上一些不法机构或个人打着项目策划指导、投融资咨询等旗号，向广大农业经营主体散布可从农业农村部申请5-50亿元巨额政策性信贷资金、无申报门槛且不需偿还等虚假信息，诱导主体通过所谓特殊渠道报送农业农村投融资项目，并借机索取高额“手续费”“咨询费”或“保证金”等。
            </p>
            <p>在此郑重提醒全省广大农业经营主体：</p>
            <p>
              一、“农业农村重大项目综合融资服务平台”是面向所有主体开放的公共服务平台，由农业农村部合作金融机构提供融资服务。各主体均可自主注册账号、按要求上传申报资料、符合申报条件即可申请“三农”领域信贷产品。通过该平台申请融资有较为严格的申报条件、审批流程和使用监管要求，切勿轻信超大额、零门槛、无偿还义务等虚假宣传，谨防上当受骗。
            </p>
            <p>
              二、若广大农业经营主体确有融资需求，可通过以下渠道申请：一是联系当地银行等正规金融机构，按要求线下提交申请；二是通过四川农业信贷直通车平台-项目融资板块或农业农村部重大项目综合融资服务平台-融资项目库板块在线填报相关信息，申请融资对接服务。
            </p>
            <p>
              三、所有政策信息务必以各地政府门户网站等官方发布为准。广大农业经营主体如有疑问，请务必咨询当地政府部门，切勿轻信第三方机构。
            </p>
            <p>
              各地农业农村部门如发现类似曲解政策、诱导主体支付高额费用承诺申报项目等可疑情况，请第一时间将线索移交相关部门依法查处。一经核准，将对涉事个人及机构在全省范围内予以通报，并纳入黑名单，禁止其从事农业相关咨询服务。
            </p>
            <p>请全省农业经营主体切实增强风险意识，提高辨识能力，共同维护良好的农村金融生态环境，守护好自己的“血汗钱”。</p>
            <p className="risk-modal__sign">
              四川省农业农村厅
              <br />
              2026年2月9日
            </p>
          </div>
        ) : (
          <div className="risk-modal__pane">
            {
              cases.map((item) => (
                <div className="risk-modal__case" key={item.title}>
                  {
                    item.data.map((row, index) => (
                      <p
                        /* eslint-disable-next-line react/no-array-index-key */
                        key={index}
                        className={[
                          row.center && 'risk-modal__case-center',
                          row.bold && 'risk-modal__case-bold',
                          row.big && 'risk-modal__case-big',
                          row.medium && 'risk-modal__case-medium',
                          /^-\s?/.test(row.text) && 'risk-modal__case-sublist',
                          /^(\d+[.、]|·)/.test(row.text) && 'risk-modal__case-list',
                        ].filter(Boolean).join(' ')}
                      >
                        {row.text}
                      </p>
                    ))
                  }
                </div>
              ))
            }
          </div>
        )}
      </div>

      <div className="risk-modal__foot">
        <div className="risk-modal__foot-tip">已阅读并知晓上述风险提示内容</div>
        <div className="risk-modal__foot-btns">
          {activePane === PANE_RISK && (
            <button type="button" className="risk-modal__btn" onClick={() => setActivePane(PANE_CASE)}>
              查看典型案例
            </button>
          )}
          <button type="button" className="risk-modal__btn risk-modal__btn-primary" onClick={onClose}>
            我知道了
          </button>
        </div>
      </div>
    </Modal>
  );
}

RiskModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
